// ---- JS: Smooth parallax using rAF and cached geometry ----
(function () {
  const parallaxEls = Array.from(document.querySelectorAll('.parallax-bg'));

  if (!parallaxEls.length) return;

  // build cache for each element
  const items = parallaxEls.map(el => {
    const section = el.closest('section') || el.parentElement;
    return {
      el,
      section,
      speed: parseFloat(el.dataset.speed) || 0.3,
      offsetTop: 0,
      height: 0,
      // optional extra: vertical center adjustment
      extra: parseFloat(el.dataset.extra) || 0
    };
  });

  // compute geometry
  function recalc() {
    items.forEach(item => {
      const sec = item.section;
      // use getBoundingClientRect relative to document top for correctness
      const rect = sec.getBoundingClientRect();
      const scrollTop = window.scrollY || window.pageYOffset;
      item.offsetTop = rect.top + scrollTop;
      item.height = sec.offsetHeight;
    });
  }

  // initial calc
  recalc();

  // update on resize and load
  window.addEventListener('resize', throttle(recalc, 150), { passive: true });
  window.addEventListener('orientationchange', recalc, { passive: true });

  // read scroll position into a variable in a passive listener
  let latestScrollY = window.scrollY || window.pageYOffset;
  window.addEventListener('scroll', () => {
    latestScrollY = window.scrollY || window.pageYOffset;
  }, { passive: true });

  // rAF loop to perform transforms once per frame
  let ticking = false;
  function rafLoop() {
    if (!ticking) {
      window.requestAnimationFrame(() => {
        updatePositions(latestScrollY);
        ticking = false;
      });
      ticking = true;
    }
    // keep loop alive by scheduling next animation frame only if needed by scroll events;
    // we rely on scroll listener to set latestScrollY and re-trigger rAF via ticking flag.
  }

  // Instead of continuously looping, call rafLoop in scroll listener:
  window.addEventListener('scroll', rafLoop, { passive: true });

  // initial render
  updatePositions(latestScrollY);

  function updatePositions(scrollY) {
    const viewportHeight = window.innerHeight;

    items.forEach(item => {
      const { el, offsetTop, height, speed, extra } = item;

      // quick visibility test
      if (scrollY + viewportHeight <= offsetTop || scrollY >= offsetTop + height) {
        // optional: hide transform when section entirely out of view to reduce paint
        // el.style.transform = '';
        return;
      }

      // compute distance from top of section
      const distance = scrollY - offsetTop;

      // an improved mapping: multiply then optionally clamp
      const translateY = (distance * speed) + extra;

      // use translate3d to promote to compositor; no layout reads here
      el.style.transform = `translate3d(0, ${translateY}px, 0)`;
    });
  }

  // simple throttle util
  function throttle(fn, wait) {
    let last = 0;
    return function (...args) {
      const now = Date.now();
      if (now - last >= wait) {
        last = now;
        fn.apply(this, args);
      }
    };
  }
})();
